import { useContext } from "react";

import { ExperimentContext } from "contexts/experiment-context";

const useExperiment = () => {
  const { experimentRef } = useContext(ExperimentContext);

  return {
    experimentId: experimentRef.current,
    setExperimentId: (id) => {
      experimentRef.current = id;
    },
  };
};
export default useExperiment;
